import React, { ReactNode } from 'react';
import { Card, Tooltip } from 'antd';
import { ChineseYuan, USDollar } from 'utils/format';

export type DollarCardProps = {
    title: string;
    amount: number;
    isDollarFormat?: boolean;
    tooltip?: string;
    children?: ReactNode;
};

export default ({
    title,
    amount,
    tooltip,
    children,
    isDollarFormat = true,
}: DollarCardProps) => {
    let amountFormatted = USDollar.format(amount);
    let fontSize = 24;
    if (amountFormatted.length > 14) {
        fontSize = 20;
    } else if (amountFormatted.length > 20) {
        fontSize = 16;
    }
    return (
        <Card
            hoverable
            bordered={false}
            style={{ width: 220, height: 100, background: '#F7F7F9' }}
        >
            <Tooltip title={tooltip}>
                <div>{title}</div>
                {isDollarFormat ? (
                    <div style={{ fontSize }}>{amountFormatted}</div>
                ) : (
                    <div style={{ fontSize }}>{amount}</div>
                )}
                {children}
            </Tooltip>
        </Card>
    );
};

type DollarCardCurrencyProps = {
    title: string;
    amountUSD: number;
    amountCNY: number;
    hasUSDPosition: boolean;
    hasCNYPosition: boolean;
    isDollarFormat?: boolean;
    tooltip?: string;
    children?: ReactNode;
};

export function DollarCardCurrency(props: DollarCardCurrencyProps) {
    const {
        title,
        amountUSD,
        amountCNY,
        hasUSDPosition,
        hasCNYPosition,
        isDollarFormat,
        tooltip,
        children,
    } = props;

    function getFontSize(amountFormatted: string) {
        let fontSize = 24;
        if (hasUSDPosition && hasCNYPosition) {
            fontSize = 20;
        }
        if (amountFormatted.length > 14) {
            fontSize = 20;
        } else if (amountFormatted.length > 20) {
            fontSize = 16;
        }
        return fontSize;
    }
    return (
        <Card
            hoverable
            bordered={false}
            style={{ width: 220, height: 100, background: '#F7F7F9' }}
        >
            <Tooltip title={tooltip}>
                <div>{title}</div>
                {!hasUSDPosition && !hasCNYPosition && (
                    <div style={{ fontSize: 24 }}>{USDollar.format(0)}</div>
                )}
                {hasUSDPosition && !hasCNYPosition && (
                    <div
                        style={{
                            fontSize: getFontSize(USDollar.format(amountUSD)),
                        }}
                    >
                        {USDollar.format(amountUSD)}
                    </div>
                )}

                {!hasUSDPosition && hasCNYPosition && (
                    <div
                        style={{
                            fontSize: getFontSize(
                                ChineseYuan.format(amountCNY)
                            ),
                        }}
                    >
                        {ChineseYuan.format(amountCNY)}
                    </div>
                )}

                {hasUSDPosition && hasCNYPosition && (
                    <>
                        <div
                            style={{
                                fontSize: getFontSize(
                                    USDollar.format(amountUSD)
                                ),
                            }}
                        >
                            {USDollar.format(amountUSD)}
                        </div>

                        <div
                            style={{
                                fontSize: getFontSize(
                                    ChineseYuan.format(amountCNY)
                                ),
                            }}
                        >
                            {ChineseYuan.format(amountCNY)}
                        </div>
                    </>
                )}
                {children}
            </Tooltip>
        </Card>
    );
}
